import { FC } from 'react';
import Lottie from 'react-lottie';
import Icon from 'components/Icon';
import colors from 'constants/colors';
import * as skeletonAnimation from '../../assets/json/small-card-skeleton.json';

interface Props {
  title: string;
  subtitle: string;
  titleValue: string;
  titleValueAbbreviated?: string;
  subtitleValue: string;
  subtitleValueAbbreviated?: string;
  badgeStyle: string;
  badgeValue: string;
  icon: string;
  isLoading?: boolean;
}

const skeletonOptions = {
  loop: true,
  autoplay: true,
  animationData: skeletonAnimation,
  rendererSettings: { preserveAspectRatio: 'xMidYMid meet' },
};

export const SmallCard: FC<Props> = ({
  title,
  subtitle,
  titleValue,
  titleValueAbbreviated = titleValue,
  subtitleValue,
  subtitleValueAbbreviated = subtitleValue,
  badgeStyle,
  badgeValue,
  icon,
  isLoading = false,
}) => {
  return (
    <div className="card card-stats">
      {isLoading ? (
        <div className="card-body">
          <Lottie options={skeletonOptions} height={140} />
        </div>
      ) : (
        <div className="card-body">
          <div className="card-row">
            <Icon name={icon} color={colors.inkBlue} size={20} />
            <span className="oath-body inkBlue">{title}</span>
          </div>
          <span className="oath-h3 inkBlue amount-full">{titleValue}</span>
          <span className="oath-h3 inkBlue amount-abbreviated" title={titleValue}>
            {titleValueAbbreviated}
          </span>
          <hr />
          <span className="oath-body gray">{subtitle}</span>
          <div className="card-row space-between">
            <span className={`big-badge ${badgeStyle} badge badge-secondary badge-pill`}>
              {badgeValue}
            </span>
            <span className="oath-h4 inkBlue amount-full">{subtitleValue}</span>
            <span className="oath-h4 inkBlue amount-abbreviated" title={subtitleValue}>
              {subtitleValueAbbreviated}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
